// --- options for settings dropdowns --- //

export const automationOptions = [
	{
		label: "1 hour",
		value: 1,
	},
	{
		label: "12 hours",
		value: 12,
	},
	{
		label: "1 day",
		value: 24,
	},
	{
		label: "5 days",
		value: 120,
	},
	{
		label: "7 days",
		value: 168,
	},
	{
		label: "1 Month",
		value: 720,
	},
	{
		label: "3 Months",
		value: 2160,
	},
	{
		label: "6 Months",
		value: 4320,
	},
	{
		label: "1 Year",
		value: 8640,
	},
];

//specifically for the away reply delay
export const automationAwayOptions = [
	{
		label: "Always Send",
		value: 0,
	},
	{
		label: "1 hour",
		value: 1,
	},
	{
		label: "12 hours",
		value: 12,
	},
	{
		label: "1 day",
		value: 24,
	},
	{
		label: "5 days",
		value: 120,
	},
	{
		label: "7 days",
		value: 168,
	},
	{
		label: "1 Month",
		value: 720,
	},
	{
		label: "3 Months",
		value: 2160,
	},
	{
		label: "6 Months",
		value: 4320,
	},
	{
		label: "1 Year",
		value: 8640,
	},
];

export const botToggleOptions = [
	{
		label: "Yes",
		value: true,
	},
	{
		label: "No",
		value: false,
	},
];

export const autoConversationAssignOptions = [
	{
		label: "Yes",
		value: true,
	},
	{
		label: "No",
		value: false,
	},
];

export const autoConversation2AssignOptions = [
	{
		label: "Yes",
		value: true,
	},
	{
		label: "No",
		value: false,
	},
];

export const treatPresubscribersAsSubscribersOptions = [
	{
		label: "Yes",
		value: true,
	},
	{
		label: "No",
		value: false,
	},
];
export const autoMoveToInboxOptions = [
	{
		label: "Yes",
		value: true,
	},
	{
		label: "No",
		value: false,
	},
];

export const hoursDaysMap = {
	0: "Always Send",
	1: "1 hour",
	12: "12 hours",
	24: "1 day",
	120: "5 days",
	168: "7 days",
	720: "1 Month",
	2160: "3 Months",
	4320: "6 Months",
	8640: "1 Year",
};

export const crmIntegrationOptions = [
    {
        label: "None",
        value: null,
    },
    {
        label: "Alto",
        value: "Alto",
    },
    {
        label: "Bullhorn CRM",
        value: "Bullhorn",
    },
    {
        label: "Email Audit",
        value: "Email Audit",
    },
    {
        label: "Eploy",
        value: "Eploy",
    },
    {
        label: "Generic Email Forwarding",
        value: "Generic Email Forward",
    },
    {
        label: "Hubspot CRM",
        value: "Hubspot",
    },
	{
        label: "JobAdder",
        value: "JobAdder",
    },
    {
        label: "Reapit Cloud",
        value: "Reapit",
    },
    {
        label: "Rex Sales CRM",
        value: "Rex",
    },
    {
        label: "Vincere",
        value: "Vincere",
    },
];

export const crmIntegrationMap = {
	null: "None",
	Alto: "Alto",
	Rex: "Rex Sales CRM",
	Bullhorn: "Bullhorn CRM",
	Hubspot: "Hubspot CRM",
	Reapit: "Reapit Cloud",
	"Generic Email Forward": "Generic Email Forwarding",
	"Email Audit": "Email Audit",
	Vincere: "Vincere",
	JobAdder: "JobAdder",
	Eploy: "Eploy"
};

export const crmFrequencyOptions = [
	{
		label: "First In/Out per day only",
		value: "FIFO",
	},
	{
		label: "Every message in/out",
		value: "ALL",
	},
	{
		label: "Never",
		value: "NONE",
	},
];

export const crmFrequencyMap = {
	FIFO: "First In/Out per day only",
	ALL: "Every message in/out",
	NONE: "Never"
};

export const EMAIL_REGEX =
	/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const tooltips = {
	defaultReplyDelay: "Controls how often the catch-all auto reply is sent. If someone messages and no keyword or phrase matches, they get the default response, usually a menu like “Thanks for messaging, choose Sales, Lettings or Support”. The delay is measured from the contact's last message, and stops them getting that same menu repeatedly. No default reply is sent after a template has been sent to the contact.",
	awayReplyDelay: "Same idea, but for out-of-hours replies. It controls how often someone receives the “we’re closed” style message, rather than spamming them every time they send another WhatsApp. The delay is measured from the contact's last message. No away reply is sent after a template has been sent to the contact, unless Away Reply is set to Always Send.",
	automatedReplyDuration: "Controls how long a bot flow waits for the customer’s next answer. If the flow asks “How many bedrooms are you looking for?” and they reply after the duration has expired, the automation stops and does not continue the question sequence.",
	humanTakeoverDuration: "When a team member replies, the bot is paused because the system treats the conversation as being handled by a human. During this period, keywords or phrases from the customer will not trigger automations.",
	turnBotOffAfterSendingTemplateMessage: "Stops the default auto reply firing when someone responds to a template. For example, if you send “Did you think about the quote?” you do not want their reply to trigger “Thanks for messaging, choose from these options.” Keyword automations can still work.",
	turnBotOffAfterBulkSendingTemplateMessage: "Same as above, but for bulk template sends. It prevents people who reply to a campaign or broadcast from being immediately pushed into the default menu.",
	autoTagPortalLeads: "When a portal lead email arrives from Rightmove, Zoopla, OnTheMarket or a similar source, the platform can tag the contact from the property address. Turn this off to stop those address tags being created. Contacts are still created and template messages are still sent.",
	automaticallyAssignConversationsToSenderWhenNotAssignedToAnIndividual: "If a chat is unassigned, or sitting with a team rather than a named person, the platform can automatically assign it to the user who replies.If it is already assigned to someone else, it stays with them unless manually changed.",
	automaticallyAssignConversationsToMostRecentSender: "This is the more aggressive version. Instead of leaving the chat with the current person or team, it keeps moving ownership to whoever most recently replied. Useful for some teams, messy for others.",
	automaticallyAssignConversationsSentViaTheAPI: "Controls whether conversations created or messaged via the API should be automatically assigned in the inbox. This matters where external systems, CRMs, forms or automations are creating outbound WhatsApp messages.",
	moveConversationsToInboxAfterSendingTemplateMessage: "Decides whether sending an outbound template should bring that chat back into the main inbox. Some businesses want this because it shows the chat as active; others prefer the inbox to show only customer replies, problems or opportunities.",
	treatPresubscribersAsIfTheyWereSubscribers: "Allows bulk broadcasts to contacts who have not yet messaged the business. This is higher risk, because they may not expect a WhatsApp from you, so they are more likely to block or report it.",
	enableInternetRegistrationsFeature: "This is a CRM-specific feature, mainly for registration-style workflows. It should only be enabled where that integration and workflow are actually being used.",
	CRMIntegration: "Controls whether the platform is connected to an external CRM. When enabled, WhatsApp activity can be pushed into the CRM contact record, helping the wider team see recent conversations, reduce manual updates, and keep customer communication history in one place."
}